import { render, staticRenderFns } from "./GameSettings.vue?vue&type=template&id=65bdd08c&scoped=true&"
import script from "./GameSettings.vue?vue&type=script&lang=js&"
export * from "./GameSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bdd08c",
  null
  
)

export default component.exports